import { render } from "./StorageConfigurationCard.vue?vue&type=template&id=0b829c08&ts=true"
import script from "./StorageConfigurationCard.vue?vue&type=script&lang=ts"
export * from "./StorageConfigurationCard.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__